<template lang="pug">
  .history-location
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.department")
        .history-label Department
        div {{ capitalize(dataOriginal.department) }}
      .history-container(v-if="dataOriginal.availableConveyors.length")
        .history-label Available Conveyors
        .capitalize {{ arrayToString(dataOriginal.availableConveyors) }}
      .history-container(v-if="dataOriginal.availableConveyorsCost.length")
        .history-label Available Conveyors Cost
        div {{ arrayToString(dataOriginal.availableConveyorsCost) }}
      .history-container(v-if="dataOriginal.availableMethods.length")
        .history-label Available Methods
        .capitalize {{ arrayToString(dataOriginal.availableMethods) }}
      .history-container(v-if="dataOriginal.availableMethodsCost.length")
        .history-label Available Methods Cost
        div {{ arrayToString(dataOriginal.availableMethodsCost) }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryUser',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-location
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/location/History.vue